var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58333 5C6.59458 5 5 6.59458 5 8.58333V28.2917C5 30.2804 6.59458 31.875 8.58333 31.875H28.2917C30.2804 31.875 31.875 30.2804 31.875 28.2917V22.9167H28.2917V28.2917H8.58333V8.58333H28.2917V12.1667H31.875V8.58333C31.875 6.59458 30.2804 5 28.2917 5M19.3333 15.75C17.3446 15.75 15.75 17.3446 15.75 19.3333V24.7083H19.3333V19.3333H39.0417V39.0417H19.3333V35.4583H15.75V39.0417C15.75 41.0304 17.3446 42.625 19.3333 42.625H39.0417C41.0304 42.625 42.625 41.0304 42.625 39.0417V19.3333C42.625 17.3446 41.0304 15.75 39.0417 15.75H19.3333Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/Connect.86d2cd64f1f262b81df48e4b98cdd6f1.svg";
export { ForwardRef as ReactComponent };